// extracted by mini-css-extract-plugin
module.exports = {"explanationItem":"ExplanationItem_explanationItem__2QFNS","image":"ExplanationItem_image__2fUFi"};